import { useActivityWithParent } from "PFApp/booking/hooks/use_activity_with_parent";
import { ReactNode } from "react";

import { BookingActivityContext, BookingActivityContextType } from "./booking_activity_context";

const BookingActivityContextProvider = ({ id, children }: { id?: number; children: ReactNode }) => {
  const {
    activity,
    parentActivity,
    isActivityFetching,
    isParentActivityFetching,
    isActivityError,
    isParentActivityError
  } = useActivityWithParent({ activityId: id });

  const value: BookingActivityContextType = {
    id,
    activity,
    parentActivity,
    isLoading: isActivityFetching || isParentActivityFetching,
    isActivityFetching,
    isParentActivityFetching,
    isActivityError,
    isParentActivityError
  };
  return <BookingActivityContext.Provider value={value}>{children}</BookingActivityContext.Provider>;
};

export default BookingActivityContextProvider;
